export class ApiService
{
    public getProduct(prodId, confId, orderProductId = null, bundleId = '')
    {
        const orderProductIdEndpoint = orderProductId !== null ? `/${orderProductId}` : '';
        let endpoint = `/api/get-product/${prodId}/${confId}${orderProductIdEndpoint}` ;

        if (bundleId !== '') {
            endpoint = `/api/get-product-bundle/${bundleId}${orderProductIdEndpoint}` ;
        }
        return fetch(endpoint)
            .then(response => response.json())
    }

    public getPrice(data)
    {
        return fetch('/api/calculate-product-price', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
        .then(response => response.json());
    }

    public setUniversalKeyInCart(status)
    {
        return fetch(`/api/set-universal-key-in-cart/${status}`)
            .then(response => response.json());
    }

    public addToCart(data)
    {
        return fetch('/api/add-to-cart', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
        .then(response => response.json());
    }

    public updateProductInTheOffer(data)
    {
        return fetch('/api/update-offer-position', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
        .then(response => response.json());
    }
}
